export default __webpack_public_path__ + "27a5c8ef2d4d5b790472167292b9872a.jpg";